import { fetchInsMonitorListDemo } from '@/lib/service';
import { EventName } from '@/shared/event-types';
import { ga_logEvent } from '@/shared/ga';
import { InsMonitorModel } from '@/types/home';
import { App, List } from 'antd';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

const CardItem = dynamic(() => import('@/components/Common/CardItem'), {
  ssr: true,
});

interface Props {
  dataList?: InsMonitorModel[];
}

const ExampleItemList = ({}: Props) => {
  const router = useRouter();
  const { message } = App.useApp();
  const [loading, setLoading] = useState(false);
  const [dataList, setDataList] = useState<InsMonitorModel[]>();

  useEffect(() => {
    setLoading(true);
    fetchInsMonitorListDemo(router.locale)
      .then((res) => {
        if (res.code === 0) {
          setDataList(res.data);
        } else {
          message.error(res.message);
        }
        setLoading(false);
      })
      .catch((error) => {
        message.error(error.message);
        setLoading(false);
      });
  }, []);

  return (
    <List loading={loading}>
      {dataList?.length > 0
        ? dataList.map((item, index) => {
            return (
              <CardItem
                data={item}
                key={index}
                isSample={true}
                onClick={(isSeeAnalytics, data) => {
                  router.push(
                    `/analytics/${item?.identification}?name=${item?.media_name}&isDemo=true&identification=${item?.identification}`
                  );
                  ga_logEvent(EventName.Sample_See_Analytics);
                }}
              />
            );
          })
        : [1, 2, 3].map((_, index) => {
            return <CardItem data={undefined} key={index} isSample={true} />;
          })}
    </List>
  );
};

export default ExampleItemList;
